import styles from './AboutUs.module.css'
import { Helmet } from 'react-helmet'

import AboutUsImage from '../../assets/aboutus.webp'

export default function AboutUs() {
  return (
    <div className="main">
      <Helmet>
        <title>About Crifty Bookkeeping | Our Story & Mission</title>
        {/*-- SEO Meta Tags --*/}
        <meta name="description" content="Learn the story behind Crifty Bookkeeping. We built this app after experiencing the chaos of small business finances firsthand, and we're dedicated to your peace of mind." />
        <meta name="keywords" content="about crifty, bookkeeping story, small business finance mission, expense tracking app, financial clarity" />
        <meta name="author" content="Crifty" />
        <link rel="canonical" href="https://crifty.com/aboutus" />
        
        {/* Open Graph / Social Media Meta Tags */}
        <meta property="og:title" content="About Crifty Bookkeeping | Our Story & Mission" />
        <meta property="og:description" content="Learn the story behind Crifty Bookkeeping. Born from chaos, built for clarity." />
        <meta property="og:image:alt" content="About Crifty Bookkeeping" />
        <meta property="og:url" content="https://crifty.com/aboutus" />
        <meta property="og:site_name" content="Crifty" /> {/* Keep this consistent across all pages */}
        <meta property="og:type" content="website" /> {/* Keep this consistent across all pages */}
        <meta property="og:image" content="https://crifty.com/OG-crifty.webp" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />

        {/*-- Twitter Meta Tags --*/}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="About Crifty Bookkeeping | Our Story & Mission" />
        <meta name="twitter:description" content="Learn the story behind Crifty Bookkeeping. Born from chaos, built for clarity." />
        <meta name="twitter:image" content="https://crifty.com/OG-crifty.webp" />
        <meta name="twitter:site" content="@CriftyApp" /> 

         <script type="application/ld+json">
          {`
            {
              "@context": "https://schema.org",
              "@type": "AboutPage",
              "name": "About Crifty Bookkeeping",
              "description": "Learn the story behind Crifty Bookkeeping. We built this app after experiencing the chaos of small business finances firsthand.",
              "url": "https://crifty.com/aboutus",
              "breadcrumb": {
                "@type": "BreadcrumbList",
                "itemListElement": [
                  {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Home",
                    "item": "https://crifty.com"
                  },
                  {
                    "@type": "ListItem",
                    "position": 2,
                    "name": "About Us"
                  }
                ]
              },
              "publisher": {
                "@type": "Organization",
                "name": "Crifty",
                "logo": {
                  "@type": "ImageObject",
                  "url": "https://crifty.com/logo.png"
                }
              }
            }
          `}
        </script>
        
      </Helmet>
      
      <div className={styles['aboutus-container']}>
        <h1>About Us: The Crifty Story – Born from Chaos, Built for Clarity</h1>
        <img 
          src={AboutUsImage}
          alt='About Crifty'
          width={512}
          height={512}
          // Modern attributes:
          loading="eager"// Eager load first image
          decoding="async" // Non-blocking image decode
          fetchPriority="high"
          className={styles['image']}
        />


        <div className="paragraph">      
          
          <p>Welcome to Crifty Bookkeeping. We’re not just another software company. 
            We’re a team of entrepreneurs, side-hustlers, and former spreadsheet warriors 
            who have been exactly where you are.</p>
          <h2>Our "Why" is Personal</h2>
          <p>Crifty was born out of late nights, overwhelming anxiety, and that sinking 
            feeling of financial disorganization. Our founder spent years running 
            a small business, passionate about the work but drowning in the paperwork.</p>

          <p>We’ve felt the dread of tax season scrambles, digging through a year’s 
            worth of crumpled receipts from the dreaded "junk drawer." We’ve known the 
            frustration of invoices gone unanswered, watching the cash flow slow to a 
            trickle because tracking who-paid-what was a part-time job in itself. 
            We’ve sat in meetings, making guesses instead of decisions because the 
            real financial picture was buried in a chaotic mix of notebooks, apps, 
            and bank statements.</p>

          <p>We lived every single one of those chaotic scenarios. And we decided: it 
            shouldn’t be this hard.</p>

          <h2>Our Mission: Your Peace of Mind</h2>
          <p>We built Crifty because we believe that managing your money should empower 
            you, not exhaust you. You started your business to pursue a passion, gain 
            freedom, and build something meaningful—not to become an accidental bookkeeper.</p>

          <p>Our mission is to give you that freedom back. We want to replace your financial 
            chaos with calm, your guesswork with confidence, and your anxiety with clarity.</p>

          <h2>What Makes Crifty Different</h2>
          <p><strong>Built on Real Experience:</strong> Unlike tools designed by faceless 
            corporations, every feature in Crifty is designed to solve a real problem we’ve 
            personally faced. We know the pain points because we’ve lived them.</p>
          <p><strong>Clarity Over Complexity:</strong> We believe powerful tools don’t have 
            to be complicated. We’ve poured our energy into making Crifty incredibly powerful 
            yet intuitive and easy to use from day one.</p>
          <p><strong>Your Success is Our Success:</strong> We’re invested in your journey. 
            When your business thrives because you have a clear financial picture, we’ve 
            done our job.</p>

          <h2>Join Our Community</h2>
          <p>You don't have to figure it out alone. Choose Crifty, and choose a partner who 
            understands the struggle and has built the solution. Let’s replace the chaos 
            with control, so you can get back to what you do best.</p>
          
        </div>

        <p className={styles['ending-p']}><strong>Here’s to building your business, on a solid foundation.</strong></p>

        <h4>The Crifty Team</h4>
      </div>
    </div>
  )
}
